import React, { useState, useEffect } from "react"
import _ from "lodash"
import { alphanum } from "components/table/lib/sort"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

import { CheckboxInput, ListboxInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const RecoveriesNamed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<object[]|null>(props.rowData[props.field]?.['namedRecoveryItems'] || []);
  const [showSelected, setShowSelected] = useState<boolean>(props.rowData[props.field]?.['namedRecoveryItems']?.length > 0);

  useEffect(() => {
    if (!props['rowData'][props.field] || !props['rowData'][props.field]?.['namedRecoveryItems']) {
      setShowSelected(false)
    }
  }, [props['rowData']])

  const updateData = (val:any) => { 
    let nextData;
    // Unselect all
    if (!val || val.length === 0){
      setData([]);
      let recoverydetail = _.cloneDeep(props.rowData[props.field])
      if (recoverydetail['namedRecoveryItems']) delete recoverydetail['namedRecoveryItems']
      props.persist(recoverydetail, props.field, props.rowData);
      return
    }
    // Select/deselect one or all
    nextData = val.map(each => {
      return {'recoveryNamedItemId': each}
    })
    setData(nextData);
    let recoverydetail = _.cloneDeep(props.rowData[props.field])
    if (!recoverydetail) recoverydetail = {}
    recoverydetail['namedRecoveryItems'] = nextData
    props.persist(recoverydetail, props.field, props.rowData)
  }

  const attrs         = (field) => field_attrs('namedRecoveryItems')(field)(props.rowData, props)
  let namedRecoveries = _.get(props, "namedItems.namedRecoveries")
  let filtered        = namedRecoveries

  if (showSelected && data){
    filtered = namedRecoveries.filter(namedRecovery => _.find(data, {'recoveryNamedItemId': namedRecovery.recoveryid}));
  }

  function selectAll():void {
    data?.length === namedRecoveries.length ? updateData(null) : updateData(namedRecoveries.map(namedRecovery => namedRecovery.recoveryid))
  }

  if (sortDirty){
    sortAsc ? filtered.sort((a, b) => alphanum(a.code, b.code)) : filtered.sort((a, b) => alphanum(b.code, a.code))
  }

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Named Recoveries</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: data && data.length > 0 ? data.length === namedRecoveries.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": data?.map(each => { if (each['recoveryNamedItemId']) return each['recoveryNamedItemId'] })}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={updateData}
            options={filtered?.map(namedRecovery => { return { label: namedRecovery['code'], value: namedRecovery.recoveryid }})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default RecoveriesNamed
